import React, { useState } from 'react';
import UserAccess from '../../../components/Contract/UserAccess';
import EmailThread from './EmialList';

const EmailSystem = ({ contract, fetchContracts}) => {
    return (
        <div className="flex justify-center items-start py-2 h-[700px]">
            <div className="grid grid-cols-8 gap-3 w-full h-full">
                <div className="col-span-2 bg-white dark:bg-[#17153B] border-[1px] border-[#CDCCCC] dark:border-[#332E82] rounded-lg p-2 h-full overflow-y-auto">
                    <UserAccess contract={contract} fetchContracts={fetchContracts} />
                </div>
                <div className="col-span-6 dark:bg-[#17153B] border-[1px] border-[#CDCCCC] dark:border-[#332E82] rounded-lg h-full overflow-y-auto">
                    <EmailThread contract={contract} fetchContracts={fetchContracts}/>
                </div>
            </div>
        </div>
    );
};

export default EmailSystem;
